import { render, staticRenderFns } from "./OtherServiceList.vue?vue&type=template&id=555022b6&"
import script from "./OtherServiceList.ts?vue&type=script&lang=js&"
export * from "./OtherServiceList.ts?vue&type=script&lang=js&"
import style0 from "./OtherServiceList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports